import { render, staticRenderFns } from "./PersonaliseModal.vue?vue&type=template&id=35753a30"
import script from "./PersonaliseModal.vue?vue&type=script&lang=js"
export * from "./PersonaliseModal.vue?vue&type=script&lang=js"
import style0 from "./PersonaliseModal.vue?vue&type=style&index=0&id=35753a30&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports